export default __webpack_public_path__ + "static/media/35.560861e7.png";